export default "__VITE_ASSET__Dv13In6O__"